export default "__VITE_ASSET__C5tsGuT7__"